import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgSeur({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M2 10.608h1.514v2.81H2v-2.81z" fill="#BDD1EC" />
      <path d="M3.513 10.608h2.595v2.81H3.513v-2.81z" fill="#6D9AD3" />
      <path d="M6.108 10.608h5.406v2.81H6.108v-2.81z" fill="#1D65B1" />
      <path
        d="M13.806 11.471s-.05-.306-.365-.306-.394.25-.224.358c.17.109.583.157.791.192.208.035.754.235.728.787-.025.553-.335.793-.598.852-.263.059-.725.213-1.317 0s-.602-.908-.602-.908h.85s-.014.39.286.39h.213c.176 0 .289-.077.289-.251s-.444-.262-.444-.262-.668-.196-.832-.28c-.163-.083-.53-.629-.04-1.175.475-.493 1.467-.294 1.7-.12.078.071.387.284.387.723h-.822zM16.793 10.682h-1.996v2.666h2.013v-.626h-1.206v-.4h1.127v-.607h-1.127v-.387h1.189v-.646zM17.741 10.69h-.783v1.652c0 .294.052 1.116 1.22 1.103 1.167-.013 1.219-.723 1.219-1.148V10.69h-.773v1.54s0 .568-.447.568-.436-.302-.436-.568v-1.54z"
        fill="#EA5128"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.97 10.664h-1.41v2.695h.783v-.967h.322c.296.022.444.138.444.347v.62h.826l-.055-.757s.04-.448-.413-.49c.35-.069.45-.47.45-.706s-.037-.742-.947-.742zm-.631 1.165v-.57h.457c.191 0 .337.05.337.285 0 .157-.123.252-.37.285h-.424z"
        fill="#EA5128"
      />
    </svg>
  )
}

export default SvgSeur
